import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isPartner", "fullScreen", "renderSearch", "compactSearchBar", "backgroundColor", "renderTabs", "onTabClick", "onCatalogOptionClick", "compactNav"];
let _ = t => t,
  _t;
import { ACHubSpotLogo } from '../ACHubSpotLogo';
import { ACNavTabs } from '../ACNavTabs';
import { ACCatalogMultiSelect } from '../ACCatalog/ACCatalogMultiSelect';
import { ACSearchInput } from '../ACSearchInput/ACSearchInput';
import { Flex } from 'foundations-components/components/Flex';
import { ACRouterLink } from 'academy-common-lib/components/ACRouterLink';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { MobileHeader } from './MobileHeader';
import styledWithTheme from 'foundations-theming/utils';
import { Box } from 'foundations-components/transitional/components/Box';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AbstractPageTemplate } from 'foundations-components/transitional/components/AbstractPageTemplate';
import { useTheme } from 'foundations-theming/utils';
import { useLocation } from 'quartz-routing/react-router';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { isNewUser } from 'academy-common-lib/utils/url';
import getLang from 'academy-common-lib/utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const HorizontalDividerOverride = styledWithTheme.div(_t || (_t = _`
  [data-test-id="abstract-page-template-header"] {
    border-block-end: ${0};
  }

  [data-test-id="abstract-page-template-header"] + * {
    border-block-start: unset;
  }
`), ({
  theme
}) => `${theme.borderWidth['100']} solid ${theme.color['border-core-subtle']}`);
export const AC_PAGE_MAX_INLINE_SIZE = 1280;
export const NEW_NAV_ALERT_KEY = 'Academy:newNavAlertDismissed';
export const NEW_USER_SEARCH_PARAMS_KEY = 'Academy:newUserSearchParams';
export const ACPage = _ref => {
  let {
      children,
      isPartner,
      fullScreen,
      renderSearch = true,
      compactSearchBar = false,
      backgroundColor = 'fill-surface-recessed',
      renderTabs = true,
      onTabClick,
      onCatalogOptionClick,
      compactNav = false
    } = _ref,
    searchInputHandlerProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobileNavbar
  } = useMediaQuery();
  const theme = useTheme();
  const navigate = useACNavigate();
  const location = useLocation();
  const startTour = () => {
    const localNewUserSearchParams = (() => {
      try {
        var _localStorage$getItem;
        return (_localStorage$getItem = localStorage.getItem(NEW_USER_SEARCH_PARAMS_KEY)) !== null && _localStorage$getItem !== void 0 ? _localStorage$getItem : '';
      } catch (error) {
        console.error(error);
        return '';
      } finally {
        try {
          localStorage.removeItem(NEW_USER_SEARCH_PARAMS_KEY);
        } catch (error) {
          console.error(error);
        }
      }
    })();
    const params = new URLSearchParams(location.search);
    if (isNewUser(location.search) || isNewUser(localNewUserSearchParams)) {
      params.set('tourId', 'academy-sign-up-tour');
    } else {
      params.set('tourId', 'academy-hubspot-sign-up-tour');
    }
    navigate({
      search: params.toString()
    }, {
      replace: true
    });
  };
  const canTakeTour = getLang() === 'en';
  const [isNewNavAlertDismissed, setIsNewNavAlertDismissed] = useState(() => {
    try {
      const newNavAlertDismissed = localStorage.getItem(NEW_NAV_ALERT_KEY);
      return Boolean(newNavAlertDismissed);
    } catch (error) {
      console.error(error);
      return false;
    }
  });
  const handleNewNavAlertDismissed = () => {
    setIsNewNavAlertDismissed(true);
    try {
      localStorage.setItem(NEW_NAV_ALERT_KEY, 'true');
    } catch (error) {
      console.error(error);
    }
  };
  const mobileMainStyles = {
    paddingBlockEnd: '0'
  };
  const desktopMainStyles = {
    marginInline: fullScreen ? '-400' : 'auto',
    maxInlineSize: fullScreen ? undefined : `${AC_PAGE_MAX_INLINE_SIZE}px`,
    paddingBlockEnd: '0'
  };
  const mobileMainSectionStyles = {
    padding: fullScreen ? undefined : '400'
  };
  const desktopMainSectionStyles = {
    marginInline: fullScreen ? '400' : undefined,
    paddingBlockStart: fullScreen ? undefined : '1000',
    paddingInline: fullScreen ? undefined : '1100',
    paddingBlockEnd: fullScreen ? undefined : '1500'
  };
  const desktopHeaderWrapperStyles = {
    backgroundColor: 'fill-surface-default',
    position: 'sticky',
    insetBlockStart: compactNav || compactSearchBar ? '0px' : '-24px',
    zIndex: 4
  };
  const mobileHeaderWrapperStyles = {
    display: 'none'
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isMobileNavbar && !isNewNavAlertDismissed && /*#__PURE__*/_jsxs(Alert, {
      closeable: true,
      onClose: handleNewNavAlertDismissed,
      type: "info",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academy-navigation-lib.ACPage.newNavAlert.title"
      }),
      children: [/*#__PURE__*/_jsx(Text, {
        display: "inline-block",
        marginInlineEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.newNavAlert.description"
        })
      }), /*#__PURE__*/_jsx(Button, {
        block: false,
        use: "tertiary",
        size: "extra-small",
        onClick: () => {
          handleNewNavAlertDismissed();
          if (canTakeTour) {
            startTour();
          }
        },
        children: canTakeTour ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.newNavAlert.quickTourButtonText"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "academy-navigation-lib.ACPage.newNavAlert.buttonText"
        })
      })]
    }), isMobileNavbar && /*#__PURE__*/_jsx(MobileHeader, Object.assign({
      compactNav: compactNav,
      isPartner: isPartner,
      renderSearch: compactNav ? false : renderSearch,
      onTabClick: onTabClick,
      onCatalogOptionClick: onCatalogOptionClick
    }, searchInputHandlerProps)), /*#__PURE__*/_jsx(HorizontalDividerOverride, {
      children: /*#__PURE__*/_jsx(AbstractPageTemplate, {
        horizontalDivider: !isMobileNavbar,
        contentAreaFlush: true,
        headerComponent: !isMobileNavbar ? /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          gap: compactNav ? '0' : '1500',
          marginBlockEnd: compactNav ? '0' : '400',
          marginBlockStart: compactNav ? compactSearchBar ? '200' : '400' : compactSearchBar ? '400' : '1000',
          marginInline: "auto",
          maxInlineSize: `${AC_PAGE_MAX_INLINE_SIZE}px`,
          children: compactNav ? /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            flexShrink: 0,
            gap: "400",
            children: [/*#__PURE__*/_jsx(ACRouterLink, {
              onClick: () => onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick('hubspot-academy'),
              to: "/",
              use: "unstyled",
              "data-onboarding": "academy-logo",
              children: /*#__PURE__*/_jsx(ACHubSpotLogo, {
                size: "md"
              })
            }), renderTabs && /*#__PURE__*/_jsx(ACNavTabs, {
              isPartner: isPartner,
              marginBlock: "0",
              onTabClick: onTabClick,
              paddingBlock: "0"
            })]
          }) : /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(ACRouterLink, {
              onClick: () => onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick('hubspot-academy'),
              to: "/",
              use: "unstyled",
              "data-onboarding": "academy-logo",
              children: /*#__PURE__*/_jsx(ACHubSpotLogo, {})
            }), renderSearch && /*#__PURE__*/_jsxs(Flex, {
              "data-onboarding-hook": "search-or-browse-topics",
              flexGrow: 1,
              gap: "400",
              maxInlineSize: "724px",
              children: [/*#__PURE__*/_jsx(ACCatalogMultiSelect, {
                minBlockSize: "117px",
                onCatalogOptionClick: onCatalogOptionClick
              }), /*#__PURE__*/_jsx(Box, {
                grow: 1,
                children: /*#__PURE__*/_jsx(ACSearchInput, Object.assign({
                  removeSearchQueryOnClear: true
                }, searchInputHandlerProps))
              })]
            })]
          })
        }) : undefined,
        headerWrapperStyles: isMobileNavbar ? mobileHeaderWrapperStyles : desktopHeaderWrapperStyles,
        pageLayout: "full-width",
        tabs: !isMobileNavbar && !compactNav && renderTabs ? /*#__PURE__*/_jsx(ACNavTabs, {
          isPartner: isPartner,
          marginInline: "auto",
          maxInlineSize: `${AC_PAGE_MAX_INLINE_SIZE}px`,
          onTabClick: onTabClick
        }) : undefined,
        mainStyles: isMobileNavbar ? mobileMainStyles : desktopMainStyles,
        mainSectionBackgroundColor: theme.color[backgroundColor],
        mainSectionStyles: isMobileNavbar ? mobileMainSectionStyles : desktopMainSectionStyles,
        children: children
      })
    })]
  });
};